import React from "react";
import PageWrapper from "../SignupPages/PageWrapper";
import "../SignupPages/SignupCommon.css";
import image from "../../assets/images/party.png";
import downloadAppBtn1 from "../../assets/images/downloadAppBtn1.png";
import downloadAppBtn2 from "../../assets/images/downloadAppBtn2.png";
const NewFunnelStep15 = () => {

  return (
    <PageWrapper>
      <div className="signup-page-container container">
        <div className="thank-you-page-container">
          <div className="thank-you-image-container">
            <img src={image} alt="Thank You" className="thank-you-image" />
          </div>
          <p className="thank-you-heading">
            Congrats! You have completed the process. You are one step closer to
            achieving your goals.
          </p>
          <p className="thank-you-description">
            Please check your inbox for updates about next steps and delivery.
          </p>

          <div className="thankyou-row-container">
            <div className="thankyou-page-banner">
              {/* Left Side Text */}
              <div className="thankyou-page-banner-left">
                Download the Claya app
                <br />
                <span className="download-app-desc">
                  Your personalized weight loss companion
                </span>
              </div>
            </div>

            {/* Buttons */}
            <div className="download-app-button-container">
              <a
                href="https://play.google.com/store/apps/details?id=com.claya.health"
                target="_blank"
                rel="noopener noreferrer"
                className="image-button"
              >
                <img
                  src={downloadAppBtn1}
                  alt="Download App Button 1"
                  className="button-image"
                />
              </a>
              <a
                href="https://apps.apple.com/us/app/claya-health/id6739589103"
                target="_blank"
                rel="noopener noreferrer"
                className="image-button"
              >
                <img
                  src={downloadAppBtn2}
                  alt="Download App Button 2"
                  className="button-image"
                />
              </a>
            </div>
          </div>
        </div>
      </div>
    </PageWrapper>
  );
};

export default NewFunnelStep15;
